import { HexColorPicker } from "react-colorful";
import React from "react";

export function ColorPicker(props: { color: string, onChange: (color: string) => void }) {
  return <HexColorPicker color={props.color} onChange={props.onChange} className="shadow rounded-lg" />;
}
